import type { IncompletePlan } from '@/api/planning/unplanned-patients';
import { careerLabel } from '@/utils/career-metadata';

// A weekly Requirement whose Weekly plans place fewer visits than it asks for,
// as the planning page's chip reads it (ADR 0001, Trello #2066).
export function incompletePlanText(plan: IncompletePlan): string {
  return `${careerLabel(plan.career)} · plan incompleto: ${plan.planned} de ${plan.visits}`;
}
